import useLocationSearch from '@app/hooks/useLocationSearch';
import { DIRECTUS_SUPER_CLIENT_URL_KEY } from '@config/common.config';

const useDirectusPreviewToken = () =>
  useLocationSearch(DIRECTUS_SUPER_CLIENT_URL_KEY);

export default useDirectusPreviewToken;
